import { render, staticRenderFns } from "./search-select.vue?vue&type=template&id=0a2c6567&scoped=true"
import script from "./search-select.vue?vue&type=script&lang=js"
export * from "./search-select.vue?vue&type=script&lang=js"
import style0 from "./search-select.vue?vue&type=style&index=0&id=0a2c6567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c6567",
  null
  
)

export default component.exports